export type InterestSeriesDefinition = {
  id: string;
  name: string;
  seriesId: string;
  branchId: string | null;
  systemDefault: boolean;
};
